/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum QuoteTestExecutionType {
  Test = "test",
  Production = "production",
}

export function instanceOfQuoteTestExecutionType(value: any): boolean {
  for (const key in QuoteTestExecutionType) {
    if (Object.prototype.hasOwnProperty.call(QuoteTestExecutionType, key)) {
      if (
        QuoteTestExecutionType[key as keyof typeof QuoteTestExecutionType] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function QuoteTestExecutionTypeFromJSON(
  json: any,
): QuoteTestExecutionType {
  return QuoteTestExecutionTypeFromJSONTyped(json, false);
}

export function QuoteTestExecutionTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestExecutionType {
  return json as QuoteTestExecutionType;
}

export function QuoteTestExecutionTypeToJSON(
  value?: QuoteTestExecutionType | null,
): any {
  return value as any;
}

export function QuoteTestExecutionTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): QuoteTestExecutionType {
  return value as QuoteTestExecutionType;
}
